// =============================================================================
// LIVE ticker — горизонтальный movement-индикатор последних ставок.
// Тянет /api/public/markets[любой] → берёт recent_bets, либо принимает извне.
// =============================================================================

interface TickerItem {
  user_handle: string;
  side: number;
  amount_usd: number;
  ago: string;
}

export function LiveTicker({ items }: { items: TickerItem[] }) {
  if (!items.length) {
    return (
      <div className="px-4 py-2 bg-accent text-bg-base flex items-center gap-3 overflow-hidden">
        <span className="display text-[11px] tracking-[0.05em] flex-shrink-0">
          <span className="pulse-dot bg-bg-base mr-1.5 align-middle" />
          LIVE
        </span>
        <span className="font-mono text-[11px] font-semibold whitespace-nowrap">
          ждём первую ставку…
        </span>
      </div>
    );
  }

  // Концатенируем дважды для бесшовной прокрутки.
  const tickerText = items
    .map((b) => `@${b.user_handle} → $${b.amount_usd.toFixed(0)} ${b.side === 1 ? 'ДА' : 'НЕТ'}`)
    .join(' · ');

  return (
    <div className="bg-accent text-bg-base flex items-center gap-3 overflow-hidden">
      <span className="display text-[11px] tracking-[0.05em] flex-shrink-0 px-4 py-2 bg-accent z-10 relative">
        <span className="pulse-dot bg-bg-base mr-1.5 align-middle" />
        LIVE
      </span>
      <div className="flex-1 overflow-hidden">
        <div className="ticker-track font-mono text-[11px] font-semibold whitespace-nowrap py-2">
          <span>{tickerText}</span>
          <span className="ml-12">{tickerText}</span>
        </div>
      </div>
    </div>
  );
}
